import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {useAppDispatch} from 'src/store/hooks';
import {getServerTimeZoneConfig} from 'src/openapi/admin/apis/ClientConfigApi';
import {selectServerTimeZone} from './serverTimeZone.slice';

export const useConfig = () => {
    const apiDispatch = useAppDispatch();

    const timeZone = useSelector(selectServerTimeZone);

    const loadServerTimeZone = useCallback(async () => {
        await apiDispatch(getServerTimeZoneConfig());
    }, []);

    return ({
        timeZone,
        loadServerTimeZone
    });
};
